import { Route } from "react-router-dom";
import RegistrationForm from "scenes/RegistrationForm";
import { RentDepositForm } from "scenes/RentDepositForm";
import {
  CostsRoute,
  ApportionmentKeysRoute,
  SettlementWizardRoute,
} from "scenes/Settlements/components/SettlementsRoutes";
import { PaymentForm } from "../../scenes/Payments/scenes/PaymentForm";
import { PaymentForm as PaymentFormV2 } from "../../scenes/Payments/scenes-v2/PaymentForm";
import { PropertyForm } from "../../scenes/PropertyForm";
import { ApplicationsRouter } from "../Applications/ApplicationsRouter";
import { getContractsScene } from "../Contracts";
import { getContractsSceneAtPropertyDetailRoot } from "../Contracts/Contracts.scene";
import { DocumentsOverviewContainer } from "../Documents/DocumentsOverviewContainer";
import { Extra } from "../Extra";
import { History } from "../History";
import { PaymentsOverviewContainer } from "../Payments/scenes-v2/PaymentsOverviewContainer";
import { TasksForProperty } from "../Tasks";
import PropertiesInGroup from "./PropertiesInGroup";
import { PropertyDetail } from "./PropertyDetail";
import { PropertyDetailDashboard } from "./PropertyDetailDashboard";

export const getPropertyDetailScene = () => (
  <Route path=":propertyId">
    {getContractsSceneAtPropertyDetailRoot()}

    <Route path="edit" element={<PropertyForm />} />

    <Route path="duplicate" element={<PropertyForm isDuplicate={true} />} />

    <Route path="payments/add" element={<PaymentForm />} />
    <Route path="payments-v1/add" element={<PaymentForm />} />
    <Route path="payments-v2/add" element={<PaymentFormV2 />} />

    <Route path="payments/:paymentOrderId/edit" element={<PaymentForm />} />
    <Route path="payments-v1/:paymentOrderId/edit" element={<PaymentForm />} />
    <Route
      path="payments-v2/:paymentOrderId/edit"
      element={<PaymentFormV2 />}
    />

    <Route
      path="contracts/:basicContractId/rent-deposit"
      element={<RentDepositForm />}
    />

    <Route
      path="contracts/:contractId/registration"
      element={<RegistrationForm />}
    />

    <Route path="costs/settlements/add" element={<SettlementWizardRoute />} />

    <Route
      path="costs/settlements/:settlementId"
      element={<SettlementWizardRoute />}
    />

    <Route element={<PropertyDetail />}>
      <Route index element={<PropertyDetailDashboard />} />

      <Route path="group-info" element={<PropertiesInGroup />} />

      <Route path="payments" element={<PaymentsOverviewContainer />} />
      <Route
        path="payments-v1"
        element={<PaymentsOverviewContainer forceVersion={1} />}
      />
      <Route
        path="payments-v2"
        element={<PaymentsOverviewContainer forceVersion={2} />}
      />

      <Route path="applications" element={<ApplicationsRouter />} />

      <Route path="documents" element={<DocumentsOverviewContainer />} />

      <Route path="history" element={<History />} />

      <Route path="extra" element={<Extra />} />

      <Route path="tasks" element={<TasksForProperty />} />

      <Route path="apportionment-keys" element={<ApportionmentKeysRoute />} />
      <Route path="costs" element={<CostsRoute />} />

      {getContractsScene()}
    </Route>
  </Route>
);
